"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const CustomViewImpl_1 = require("../../Impl/CustomViewImpl");
const ServiceImplBase_1 = require("./ServiceImplBase");
class VizServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "viz-service" /* Viz */;
    }
    createVizImageAsync(inputSpec) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'createVizImageAsync',
            [api_internal_contract_js_1.ParameterId.VizAPIInputJson]: JSON.stringify(inputSpec),
        };
        return this.execute(api_internal_contract_js_1.VerbId.VizAPI, parameters).then((response) => {
            const result = response.result;
            return result;
        });
    }
    activateSheetAsync(name) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'activateSheetAsync',
            [api_internal_contract_js_1.ParameterId.SwitchToSheetName]: name,
        };
        return this.execute(api_internal_contract_js_1.VerbId.ActivateSheet, parameters).then(() => {
            return;
        });
    }
    getCustomViewsAsync() {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getCustomViewsAsync',
        };
        return this.execute(api_internal_contract_js_1.VerbId.GetCustomViews, parameters).then((response) => {
            const customViews = response.result;
            return customViews.map((customView) => {
                return new CustomViewImpl_1.CustomViewImpl(customView, this._registryId);
            });
        });
    }
    showCustomViewAsync(customViewName) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'showCustomViewAsync',
            [api_internal_contract_js_1.ParameterId.CustomViewName]: customViewName || '',
        };
        return this.execute(api_internal_contract_js_1.VerbId.ShowCustomView, parameters).then((response) => {
            var _a;
            const customView = response.result;
            return ((_a = customView) === null || _a === void 0 ? void 0 : _a.luid) ? new CustomViewImpl_1.CustomViewImpl(customView, this._registryId) : undefined;
        });
    }
    removeCustomViewAsync(customViewName) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'removeCustomViewAsync',
            [api_internal_contract_js_1.ParameterId.CustomViewName]: customViewName,
        };
        return this.execute(api_internal_contract_js_1.VerbId.RemoveCustomView, parameters).then((response) => {
            const customView = response.result;
            return new CustomViewImpl_1.CustomViewImpl(customView, this._registryId);
        });
    }
    saveCustomViewAsync(customViewName) {
        // CustomViewIsDefault is a required parameter, but our API has not been updated to allow it to be specified yet.
        // We should add a 'default' parameter to the interface.
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'saveCustomViewAsync',
            [api_internal_contract_js_1.ParameterId.CustomViewName]: customViewName,
            [api_internal_contract_js_1.ParameterId.CustomViewIsDefault]: false,
        };
        return this.execute(api_internal_contract_js_1.VerbId.SaveWorkbookAsCustomView, parameters).then((response) => {
            const customView = response.result;
            return new CustomViewImpl_1.CustomViewImpl(customView, this._registryId);
        });
    }
    setActiveCustomViewAsDefaultAsync() {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'setActiveCustomViewAsDefaultAsync',
        };
        return this.execute(api_internal_contract_js_1.VerbId.SetActiveCustomViewAsDefault, parameters).then(() => {
            return;
        });
    }
    saveAsync(customView) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'saveAsync',
            [api_internal_contract_js_1.ParameterId.CustomViewLuid]: customView.luid,
            [api_internal_contract_js_1.ParameterId.CustomViewName]: customView.name,
            [api_internal_contract_js_1.ParameterId.CustomViewIsDefault]: customView.isDefault,
            [api_internal_contract_js_1.ParameterId.CustomViewIsPublic]: customView.shared,
        };
        return this.execute(api_internal_contract_js_1.VerbId.UpdateCustomView, parameters).then((response) => {
            const customView = response.result;
            return new CustomViewImpl_1.CustomViewImpl(customView, this._registryId);
        });
    }
    getCurrentSrcAsync() {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getCurrentSrcAsync',
        };
        return this.execute(api_internal_contract_js_1.VerbId.GetCurrentSrc, parameters).then((response) => response.result);
    }
}
exports.VizServiceImpl = VizServiceImpl;
//# sourceMappingURL=VizServiceImpl.js.map